import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledTitle = styled(Typography)({
  flex: '1 1 100%',
});

export const Title = (props) => {
  const { color = null, ...rest } = props;
  
  return (
    <StyledTitle 
      component="h2" 
      variant="h6" 
      color={color ? color : "default"} 
      gutterBottom 
      {...rest}
    >
      {props.children}
    </StyledTitle>
  );
};